import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, ToastProvider } from '@dru/ui';
import { AuthProvider } from './lib/auth';
import { AppRouter } from './app/router';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      {/* Outermost of the app providers: the theme is a property of the
          document, not of a session, so it applies on the login screen and
          survives signing out. */}
      <ThemeProvider>
        <AuthProvider>
          {/* Outside the router so a confirmation survives the navigation that
              follows the action it is confirming. */}
          <ToastProvider>
            <AppRouter />
          </ToastProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
